module.exports = __webpack_public_path__ + "img/niu12.9546209d.jpg";